var map = {
	"./demos/basic/index.ts": 71200,
	"./demos/border/index.ts": 21837,
	"./demos/closable/index.ts": 4182,
	"./demos/color/index.ts": 69235,
	"./demos/draggable/index.ts": 13836,
	"./demos/size/index.ts": 92405,
	"./demos/tags/index.ts": 25297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96855;